import { createSelector } from 'reselect';

const getFavouritesData = (state) => {
  const { details: { partnerProductId: omsId } } = state.product;
  const { memberData: { listId, listName } } = state.favorite;
  return {
    omsId,
    listId,
    listName,
  };
};
export const favouritesSelector = createSelector(
  state => state,
  getFavouritesData,
);
